import merge from 'lodash/merge.js';
export default function getFormInitialValues(defaultValues, record) {
    var finalInitialValues = merge({}, getValues(defaultValues, record), record);
    return finalInitialValues;
}
function getValues(values, record) {
    if (typeof values === 'object') {
        return values;
    }
    if (typeof values === 'function') {
        return values(record);
    }
    return {};
}
//# sourceMappingURL=getFormInitialValues.js.map